enum ProductType {
  Membership = 'Membership',
  PrivateSpace = 'Private Space',
  Course = 'Course',
  Bundle = 'Bundle',
  InPersonOnly = 'In-person only',
  DigitalDownload = 'Digital download',
  PrepaidClassCard = 'Prepaid ClassCard',
  PrivateCoaching = 'Private Coaching',
}
export default ProductType;
